// Initialize OWL sliders
import truncate from 'truncate-html';

//interviews owl
let interviewsLimit = 2,
  interviewsOffset = 4,
  interviewsEnd = false,
  interviewRequestProcessing = false;

let studioShotLimit = 3,
  studioShotOffset = 9,
  studioShotEnd = false,
  studioShotRequestProcessing = false;

//published book owl
let limitPublishedBook = 2,
  offsetPublishedBook = 4,
  endPublishedBook = false,
  publishedBookRequestProcessing = false,
  exceptIds = [];

//news owl
let limit = 2,
  offset = 4,
  end = false,
  newsRequestProcessing = false;

window.$(document).ready(function () {
  var owlTestimonials = window.$('.testimonial-slides.owl-carousel');
  owlTestimonials.owlCarousel({
    items: 1,
    loop: true,
    center: true,
    nav: true,
    autoHeight: true,
  });
  setTimeout(function () {
    owlTestimonials.trigger('next.owl.carousel');
    owlTestimonials.trigger('prev.owl.carousel');
  }, 300);
  var owlPublishers = window.$('.publishers.owl-carousel');
  owlPublishers.owlCarousel({
    items: 5,
    center: true,
    autoplay: true,
    autoplayTimeout: 1500,
    loop: true
  });
  var owlPublishersFrontPage = window.$('.publishers.front-page.owl-carousel');
  owlPublishersFrontPage.owlCarousel({
    items: 3,
    center: true,
    autoplay: true,
    autoplayTimeout: 1500,
    loop: true,
    dots: false
  });
  var owlNewsGallery = window.$('.blog__gallery.owl-carousel');
  owlNewsGallery.owlCarousel({
    items: 1,
    center: true,
    autoplay: true,
    autoplayTimeout: 2500,
    loop: true
  });
  // var owlStudioShots = window.$('.studio-shot-slides.owl-carousel');
  // owlStudioShots.owlCarousel();

  let studioShotsOwlSliderOptions = {
    items: 3,
    center: false,
    autoplay: true,
    autoplayTimeout: 125000,
    loop: false,
    nav: true
  };

  let owlOptions = {
    nav: true,
    margin: 40,
    items: 3,
    dots: true,
    lazyLoad: true,
    responsive: {
      0: {
        margin: 0,
        nav: false,
        items: 1
      },
      621: {
        margin: 20,
        items: 2,
        nav: false,
      },
      701: {
        margin: 30,
        items: 2,
        nav: false,
      },
      961: {
        items: 3
      }

    }
  };

  window.$(".ci-carousel").owlCarousel(owlOptions);

  if (window.$('#featured_news_slider').length) {
    let newsOwl = window.$('#featured_news_slider').owlCarousel(owlOptions);
    let navigationOwlCarousel = window.$('#featured_news_slider').data('owl.carousel')._plugins.navigation;

    navigationOwlCarousel.update = navigationUpdate;

    window.$('#featured_news_slider').trigger('refresh.owl.carousel');

    newsOwl.on('changed.owl.carousel', function (e) {
      if (((e.page.index + 2) >= e.page.count) && !end && !newsRequestProcessing) {
        loadNews();
      }
    });
  }

  if (window.$('#published_book_owl_slider').length) {
    window.$('#published_book_owl_slider').find('.item-block').each((index, block) => {
      return exceptIds.push($(block).data('id'));
    });

    let publishedBookOwl = window.$('#published_book_owl_slider').owlCarousel(owlOptions);
    let navigationPublishedBook = window.$('#published_book_owl_slider').data('owl.carousel')._plugins.navigation;

    navigationPublishedBook.update = navigationUpdate;

    window.$('#published_book_owl_slider').trigger('refresh.owl.carousel');

    publishedBookOwl.on('changed.owl.carousel', function (e) {
      if (((e.page.index + 2) >= e.page.count) && !endPublishedBook && !publishedBookRequestProcessing) {
        loadPublishedBooks();
      }
    });
  }

  if (window.$('#interviews_owl_slider').length) {
    let interviewsOwl = window.$('#interviews_owl_slider').owlCarousel(owlOptions);
    let navigationInterviewOwlCarousel = window.$('#interviews_owl_slider').data('owl.carousel')._plugins.navigation;

    navigationInterviewOwlCarousel.update = navigationUpdate;

    window.$('#interviews_owl_slider').trigger('refresh.owl.carousel');

    interviewsOwl.on('changed.owl.carousel', function (e) {
      if (((e.page.index + 2) >= e.page.count) && !interviewsEnd && !interviewRequestProcessing) {
        loadInterviews();
      }
    });
  }


  let studioShotOwl = window.$('#studio-shot-slides').owlCarousel(studioShotsOwlSliderOptions);

  studioShotOwl.on('changed.owl.carousel', function (e) {
    if (((e.page.index + 2) >= e.page.count) && !studioShotEnd && !studioShotRequestProcessing) {
      loadStudioShots();
    }
  });
});

//Use for changing navigation owlCarousel
function navigationUpdate() {
  var i, j, k, size = 6,
    lower = this._core.clones().length / 2,
    upper = lower + this._core.items().length,
    maximum = this._core.maximum(true),
    settings = this._core.settings;

  this._pages = [
    {start: 0, end: 2},
    {start: 1, end: 3},
    {start: 3, end: 5},
  ];

  if (settings.dots || settings.slideBy == 'page') {
    for (i = lower, j = 0, k = 0; i < upper; i++) {
      if (j >= size || j === 0) {
        if (Math.min(maximum, i - lower) === maximum) {
          break;
        }
        j = 0, ++k;
      }
      j += this._core.mergers(this._core.relative(i));
    }
  }
}

function loadInterviews() {
  interviewRequestProcessing = true;
  $.ajax({
    url: '/api/publisher-interviews',
    type: 'GET',
    data: {
      limit: interviewsLimit,
      offset: interviewsOffset,
      order_by: 'weight',
      order_dir: 'asc',
    },
    dataType: 'json',
    success: function (interviews) {
      interviewsOffset += interviewsLimit;

      interviewsEnd = interviewsOffset === 6;

      displayInterviews(interviews);
    },
  });
}

function loadStudioShots() {
  studioShotRequestProcessing = true;

  $.ajax({
    url: '/api/studio-shots/' + $('#illustrator_id').val(),
    type: 'GET',
    data: {
      limit: studioShotLimit,
      offset: studioShotOffset,
    },
    dataType: 'json',
    success: function (studioShots) {
      studioShotRequestProcessing = false;

      studioShotOffset += studioShotLimit;

      if (studioShots < studioShotLimit) {
        studioShotEnd = true;
      }

      displayStudioShots(studioShots);
    },
  });
}

function loadPublishedBooks() {
  publishedBookRequestProcessing = true;

  $.ajax({
    url: '/api/published-books',
    type: 'GET',
    data: {
      offset: offsetPublishedBook,
      limit: limitPublishedBook,
      except_ids: exceptIds
    },
    dataType: 'json',
    success: function (publishedBooks) {
      offsetPublishedBook += limitPublishedBook;
      endPublishedBook = offsetPublishedBook === 6;
      publishedBookRequestProcessing = false;

      displayPublishedBooks(publishedBooks);
    },
  });
}

function loadNews() {
  newsRequestProcessing = true;
  let exceptIds = [];
  $('#featured_news_slider .item-block--news').each(function() {
    exceptIds.push($(this).data('id'));
  });

  $.ajax({
    url: '/api/featured-news',
    type: 'GET',
    data: {
      limit,
      exceptIds,
    },
    dataType: 'json',
    success: function (news) {
      offset += limit;
      end = offset === 6;
      newsRequestProcessing = false;

      displayNews(news);
    },
  });
}

function displayInterviews(interviews) {
  for (let key in interviews) {
    let interview = interviews[key];


    let template = $('.interview_template').first().clone();
    template.removeClass('interview_template');

    let allAnswers = interview.interview_answers.reduce((concat, answer) => {
      return concat + answer.text;
    }, '');

    let link = '/interviews/' + interview.identificator;
    template.find('.thumb-link').attr('href', link);
    template.find('.second_interviews_link').attr('href', link);
    template.find('.second_interviews_link .span1').text(interview.name);
    template.find('.second_interviews_link .span2').text(interview.position);
    template.find('.item-block__excerpt').html(truncate(allAnswers, 170));
    template.find('.item-block__more-link').attr('href', link);
    template.find('.interviews_cover_image').attr('src', interview.imagePath);
    template.find('.interviews_cover_image').attr('alt', interview.name + ' Interview');

    template.css('display', 'block');

    window.$('#interviews_owl_slider').owlCarousel('add', template).owlCarousel('update').trigger('refresh.owl.carousel');
  }

  interviewRequestProcessing = false;
}

function displayStudioShots(studioShots) {
  for (let key in studioShots) {
    let studioShot = studioShots[key];

    let template = $('.studio-shot-template').first().clone();
    template.removeClass('studio-shot-template');

    template.find('img').attr('src', studioShot.smallImage);
    template.find('img').attr('data-original-src', studioShot.bigImage);

    template.css('display', 'block');

    window.$('#studio-shot-slides').owlCarousel('add', template).owlCarousel('update').trigger('refresh.owl.carousel');
  }
}

function displayPublishedBooks(publishedBooks) {
  for (let key in publishedBooks) {
    let publishedBook = publishedBooks[key];
    let link = `/books/${publishedBook.id}`;
    let illustratorLink = `/${publishedBook.illustrator.user.name}/published-books`;
    let illustratorFullName = `${publishedBook.illustrator.first_name} ${publishedBook.illustrator.last_name}`;
    let template = $('.published_book_template').first().clone();

    template.removeClass('published_book_template');

    template.find('.thumb-link').attr('href', link);

    template.find('.item-block__profile-pic').attr('href', illustratorLink);
    template.find('.avatar').attr('src', publishedBook.illustratorAvatarPath);

    template.find('.published_book_cover_image').attr('src', publishedBook.imagePath);
    template.find('.published_book_cover_image').attr('alt', `${publishedBook.title} by ${illustratorFullName}`);

    template.find('.title').attr('href', link);
    template.find('.title').text(illustratorFullName);

    template.css('display', 'block');

    window.$('#published_book_owl_slider').owlCarousel('add', template).owlCarousel('update').trigger('refresh.owl.carousel');
  }
}

function displayNews(news) {
  for (let key in news) {
    let item = news[key];
    let template = $('.news-template').first().clone();
    template.removeClass('news-template');

    let link = '/news/' + item.identificator;
    template.find('.thumb-link').attr('href', link);
    template.find('.second_news_link').attr('href', link);
    template.find('.item-block__more-link').attr('href', link);
    template.find('.item-block__excerpt').html(truncate(item.text, 170));
    template.find('.news_cover_image').attr('src', item.imagePath);
    template.find('.second_news_link').text(item.title);
    template.find('.news_cover_image').attr('alt', item.title);

    template.css('display', 'block');

    window.$('#featured_news_slider').owlCarousel('add', template).owlCarousel('update').trigger('refresh.owl.carousel');
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/owl.js